module.exports = __webpack_public_path__ + "static/media/img2.bced8887.jpeg";